'use client';

import React from 'react';

import { Switch } from '@shaojiang/components/ui/switch';
import useShaojiangTheme from '@shaojiang/hooks/useShaojiangTheme';
import { ThemeMode } from '@shaojiang/theme/modes';

export default function ThemeSwitch() {
  const { theme, setTheme } = useShaojiangTheme();

  return (
    <Switch
      checked={theme === ThemeMode.Dark}
      onCheckedChange={({ checked }) => setTheme(checked ? ThemeMode.Dark : ThemeMode.Light)}
    >
      Dark Mode
    </Switch>
  );
}
